import React from 'react';
import { useParams } from 'react-router-dom';
import ManufacturingDetailContainer from '../../containers/manufacturingmng/ManufacturingDetailContainer';

const ManufacturingDetailPage = () => {
  const { projectId, planId } = useParams();
  const pageUrl = '/manufacturingmng';
  
  return <ManufacturingDetailContainer projectId={projectId} planId={planId} pageUrl={pageUrl} />;
};

export default ManufacturingDetailPage;
